module.exports = __webpack_public_path__ + "img/gzh.e32d957a.png";